var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product" },
    [
      _c(
        "div",
        { staticClass: "filter" },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品分类：" } },
                [
                  _c("el-cascader", {
                    staticClass: "selWidth mr20",
                    attrs: {
                      options: _vm.merCateList,
                      props: _vm.props,
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.cateId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cateId", $$v)
                      },
                      expression: "form.cateId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.form.productName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "productName", $$v)
                      },
                      expression: "form.productName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品编号：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.form.productCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "productCode", $$v)
                      },
                      expression: "form.productCode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "ios-search",
                    label: "default",
                    size: "small",
                  },
                  on: { click: _vm.search },
                },
                [
                  _c("i", { staticClass: "el-icon-search el-icon--left" }),
                  _vm._v("\n        搜索\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData.list },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productCode",
                  label: "产品编号",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "产品名称",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "facevalue", label: "面值", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "value", label: "价格", align: "center" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openUpdatePrice(scope.row)
                              },
                            },
                          },
                          [_vm._v("更新价格")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteProduct(scope.row)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("el-pagination", {
            attrs: {
              "page-sizes": [15, 30, 45, 60],
              "page-size": _vm.pageFrom.limit,
              "current-page": _vm.pageFrom.page,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.tableData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("UpdatePriceVue", {
        ref: "UpdatePriceVueRef",
        attrs: { id: _vm.id },
        on: { refresh: _vm.search },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }